module.exports = __webpack_public_path__ + "img/ok.d2655c6c.png";